import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import ScoreCalculationConfiguration from "Administrator/commonComponents/GradingSetupV2/routes/ScoreCalculationConfiguration";
import GradingMethodology from "Administrator/commonComponents/GradingSetupV2/routes/GradingMethodology";
import GradingCategoriesConfiguration from "Administrator/commonComponents/GradingSetupV2/routes/GradingCategoriesConfiguration";
import GradeScales from "Administrator/commonComponents/GradingSetupV2/routes/GradeScales";
import StandardCalculationConfiguration from "Administrator/commonComponents/GradingSetupV2/routes/StandardCalculationConfiguration";
import GradeScalesAndDescriptors from "Administrator/commonComponents/GradingSetupV2/routes/GradeScalesAndDescriptors";
import ProjectProgressIndicators from "Login/routes/Administrator/commonComponents/ProjectProgressIndicators";

export default store => ({
  path: "grading",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    GradingMethodology(store),
    GradeScales(store),
    GradingCategoriesConfiguration(store),
    ScoreCalculationConfiguration(store),
    StandardCalculationConfiguration(store),
    GradeScalesAndDescriptors(store),
    ProjectProgressIndicators(store),
  ],
});
